import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { D3Event } from '../charts.model';
import { HierarchyNode } from 'd3-hierarchy';
import { SunburstData } from '../sunburst-chart-base/sunburst-chart-base.model';

@Component({
  selector: 'app-sunburst-chart-wrapper',
  templateUrl: './sunburst-chart-wrapper.component.html',
  styleUrls: ['./sunburst-chart-wrapper.component.scss'],
})
export class SunburstChartWrapperComponent implements OnInit {
  @Input() chartHeader: string;
  @Input() data: any;
  @Input() infoTitle: string;
  @Input() colorRange: string[];

  @Output() elementClick = new EventEmitter<
    D3Event<HierarchyNode<SunburstData>>
  >();

  infoValue: string;
  infoLabel: string;
  showInfo: boolean;
  dataForLegend: any = [];

  constructor() {}

  ngOnInit() {
    this.prepareDataForLegend();
  }

  onMouseOver(event: D3Event<HierarchyNode<SunburstData>>) {
    const { d } = event;
    this.showInfo = true;
    this.infoValue = this.prepareMainDescription(d);
    this.infoLabel = d.data.label;
  }

  onMouseOut(event: D3Event<HierarchyNode<SunburstData>>) {
    this.showInfo = false;
  }

  onElementClick(event: D3Event<HierarchyNode<SunburstData>>) {
    this.elementClick.emit(event);
  }

  private prepareDataForLegend() {
    this.data.children.forEach((child) => {
      let sumOfValues = 0;
      child.children.forEach((innerChild) => {
        if (innerChild.value > 0) {
          this.dataForLegend.push({
            label: innerChild.label,
            value: innerChild.value,
            color: innerChild.color,
          });
          sumOfValues += innerChild.value;
        }
      });
      if (sumOfValues) {
        this.dataForLegend.unshift({
          label: child.label,
          value: child.value,
          color: child.color,
        });
      }
    });
    if (this.dataForLegend.length) {
      this.dataForLegend = this.dataForLegend.sort((a, b) =>
        a.label > b.label ? 1 : -1
      );
    }
  }

  private prepareMainDescription(node: HierarchyNode<SunburstData>): string {
    const sum = node.parent.value;
    const percentage = (node.value * 100) / sum;
    return `${node.value} (${percentage.toFixed(0)}%)`;
  }
}
